import React from 'react';
import Box from '@mui/material/Box';

export default function CardList(props) {
    return (
        <Box sx={{ alignItems: 'center', maxWidth: '500px',
            width: '100%', display: 'flex', flexDirection: 'column',
            ...(props.sx || {}) }}>
            { props.children }
        </Box>
    )
}
